import { Instagram, Phone, MapPin } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { SALON_INFO } from "../data/assets";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  const go = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      className="relative bg-[#030303] border-t border-white/5 pt-20 pb-10"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="font-display text-3xl text-white mb-4">
              <span className="text-[#C5A059]">L</span>uxury{" "}
              <span className="italic text-white/70">Salón</span>
            </div>
            <p className="text-sm text-white/50 font-light leading-relaxed max-w-sm">
              {t.footer.tagline}
            </p>
            <div className="mt-8 flex items-center gap-3">
              <a
                href={SALON_INFO.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 px-4 h-10 rounded-full border border-white/15 hover:border-[#C5A059] text-white/70 hover:text-[#C5A059] transition-all"
                aria-label="Instagram"
                data-testid="footer-instagram"
              >
                <Instagram size={16} strokeWidth={1.5} />
                <span className="text-xs uppercase tracking-[0.2em]">@salon_luxury_zilina</span>
              </a>
            </div>
          </div>

          {/* Sections */}
          <div className="md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#C5A059] mb-5">
              {t.footer.sections}
            </div>
            <ul className="space-y-3">
              {["about", "services", "reviews", "gallery", "hours", "contact"].map((id) => (
                <li key={id}>
                  <button
                    onClick={() => go(id)}
                    className="text-sm text-white/60 hover:text-white transition-colors"
                    data-testid={`footer-link-${id}`}
                  >
                    {t.nav[id]}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#C5A059] mb-5">
              {t.footer.contact}
            </div>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-white/60">
                <MapPin size={16} className="text-[#C5A059] mt-0.5 flex-shrink-0" strokeWidth={1.5} />
                <span>{SALON_INFO.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-[#C5A059] flex-shrink-0" strokeWidth={1.5} />
                <a
                  href={`tel:${SALON_INFO.phoneIntl}`}
                  className="text-sm text-white/60 hover:text-[#C5A059] transition-colors"
                  data-testid="footer-phone"
                >
                  {SALON_INFO.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4 text-[11px] uppercase tracking-[0.2em] text-white/30">
          <div data-testid="footer-copyright">
            © {year} Luxury Salón. {t.footer.rights}
          </div>
          <div className="italic text-white/25 normal-case tracking-normal text-xs">
            {t.footer.crafted}
          </div>
        </div>
      </div>
    </footer>
  );
};
